'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var rotateInUpRight = {
  from: {
    transformOrigin: 'right bottom',
    transform: (0, _utils.rotate3d)(0, 0, 1, -90),
    opacity: 0
  },
  to: {
    transformOrigin: 'right bottom',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateInUpRight;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/rotate-in-up-right.js
// module id = 784
// module chunks = 0